import React, { Component } from 'react';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { getFirstLastDayWeek, AddDays, RemoveDays, formatDate } from '../../utils';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import { GetLanguage } from '../../utils/language';
import * as storage from '../../utils/storage'
import { Calendar } from "@progress/kendo-react-dateinputs";
import Button from '@material-ui/core/Button';
import { IntlProvider, LocalizationProvider } from "@progress/kendo-react-intl";
import moment from "moment";
import "moment/locale/fr";
import styles from '../../styles/timesheet.module.css';

moment.locale("fr");

class TimesheetWeekSelect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            startWeekDay: storage.getStartDayTimesheet(),
            startDate: null,
            endDate: null,
            selectedDate: null,
            locale: 'fr',
            saveDate: this.props.saveDate,
            showCalendar: styles.hideCalendar
        }
    }

    componentDidUpdate(prevProps) {
        // This is to load the date that was saved in the form
        if (prevProps.saveDate !== this.props.saveDate && this.props.saveDate !== null) {
            this.loadTargetDate(new Date(formatDate(this.props.saveDate, 'date', '/') + ' 00:00'));
        }
    }

    componentDidMount() {
        const language = GetLanguage();

        moment.locale(language);
        this.setState({ locale: language });

        this.loadTargetDate(new Date());
    }

    loadTargetDate = (date) => {
        const weekDay = getFirstLastDayWeek(date, this.state.startWeekDay);

        this.setState(
            {
                startDate: weekDay.firstDay,
                endDate: weekDay.lastDay
            }, () => {
                this.onChangeDate(this.state.startDate, this.state.endDate);
            });
    }

    onChangeDate = (startDate, endDate) => {
        this.props.onChangeDate(startDate, endDate);
    }

    handleWeekBefore = () => {
        const beforeDay = RemoveDays(this.state.startDate, 1);

        this.getFirstLastDay(beforeDay);
    }

    handleWeekAfter = () => {
        const nextDay = AddDays(this.state.endDate, 1);
        this.getFirstLastDay(nextDay);
    }

    getFirstLastDay = (date) => {
        const weekDay = getFirstLastDayWeek(date, this.state.startWeekDay);

        this.setState(
            {
                startDate: weekDay.firstDay,
                endDate: weekDay.lastDay,
                selectedDate: new Date(formatDate(weekDay.firstDay, 'date'))
            }, () => {
                this.onChangeDate(this.state.startDate, this.state.endDate);
            });
    }

    handleDatePicker = () => {
        this.setState({ showCalendar: styles.showCalendar });
    }

    handleCancelCalendar = () => {
        this.setState({ showCalendar: styles.hideCalendar });
    }

    handleDateChange = (event) => {
        this.getFirstLastDay(event.target.value);
        this.setState({ showCalendar: styles.hideCalendar });
    }

    render() {
        return (
            <div id="divWeekSelect" className={styles.rootTimesheetSelect}>
                <IconButton id="btnWeekBefore" size="small" aria-label="close" color="inherit" onClick={this.handleWeekBefore}>
                    <ArrowBackIosIcon fontSize="small" />
                </IconButton>
                <IconButton size="small" aria-label="close" color="inherit" onClick={this.handleDatePicker}>
                    {this.state.startDate} {i18next.t("timesheet:week-select.to")} {this.state.endDate}
                </IconButton>
                <IconButton id="btnWeekAfter" size="small" aria-label="close" color="inherit" onClick={this.handleWeekAfter}>
                    <ArrowForwardIosIcon fontSize="small" />
                </IconButton>
                <div className={styles.datePicker + ' ' + this.state.showCalendar}>
                    <LocalizationProvider language={this.state.locale}>
                        <IntlProvider locale={this.state.locale}>
                            <div>
                                <Calendar onChange={this.handleDateChange} />
                                <div>
                                    <Button
                                        className={styles.cancelButton}
                                        variant="contained"
                                        color="primary"
                                        onClick={this.handleCancelCalendar}
                                    >
                                        {i18next.t('buttons:cancel')}
                                    </Button>
                                </div>
                            </div>
                        </IntlProvider>
                    </LocalizationProvider>
                </div>
            </div>
        );
    }
}

export default withNamespaces(['timesheet', 'buttons'], { wait: true })(TimesheetWeekSelect);